<template>
    <img id="icon" class="img-fluid rounded mx-auto d-block" src="assets/icon-450.png" alt="The knockturnmc icon">
</template>

<script>
    export default {
        name: "Icon"
    }
</script>

<style scoped>

    /**
    Also untouchable, this will have an absolute position in the top middle of the website.
     */
    #icon {
        position: absolute;
        max-width: 100%;
        height: auto;
        width: auto\9; /* ie8 */
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: -1;
    }
</style>